import { render, staticRenderFns } from "./BundleInsurancePatientAmountModal.vue?vue&type=template&id=f8d5d550&scoped=true"
import script from "./BundleInsurancePatientAmountModal.vue?vue&type=script&lang=js"
export * from "./BundleInsurancePatientAmountModal.vue?vue&type=script&lang=js"
import style0 from "./BundleInsurancePatientAmountModal.vue?vue&type=style&index=0&id=f8d5d550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d5d550",
  null
  
)

export default component.exports